export default "__VITE_ASSET__BcID1amp__"